/**
 * Card-number format check for the payment forms. Accepts Visa (13/16),
 * Mastercard (51-55 and the 2221-2720 range) and American Express
 * (34/37, 15 digits). Brand acceptance per tenant is enforced by the
 * payment gateway; this only rejects malformed numbers.
 */
export const CARD_NUMBER_PATTERN =
  /^(4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9]{2}|7(?:[01][0-9]|20))[0-9]{12}|3[47][0-9]{13})$/;

// Amex uses a 4-digit CID; Visa/Mastercard use 3 digits.
export const CVC_PATTERN = /^\d{3,4}$/;
